'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('NoAccessCtrl', NoAccessCtrl);
  NoAccessCtrl.$inject = [];

  function NoAccessCtrl() {}
})();